import http from "@/http/aisea/axios_v2";
import qs from "qs";

const resource = "/enterprises/manning/vessels/crews";

export default {
  show(id, payload) {
    return http.get(`${resource}/${id}`, {
      params: payload,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },

  updateRemark(id, data) {
    return http.put(`${resource}/${id}/remarks`, data);
  },
};